/* Shared pure rules for truthful product conversion information. No network or order writes. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.HahConversion = api;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var DAY = 86400000;

  function integer(value, low, high) {
    return typeof value === 'number' && Number.isSafeInteger(value) && value >= low && value <= high;
  }
  function config(raw) {
    var result = { enabled: { sales: false, reviews: true, savings: true, delivery: false },
      sales: { minimum_units: 100, max_age_hours: 36 }, delivery: null };
    if (!raw) return result;
    if (raw.schema !== 'hah-conversion/v1' || !raw.enabled) {
      result.enabled.reviews = result.enabled.savings = false;
      return result;
    }
    Object.keys(result.enabled).forEach(function (key) { result.enabled[key] = raw.enabled[key] === true; });
    if (raw.sales && integer(raw.sales.minimum_units, 1, 1000000) && integer(raw.sales.max_age_hours, 1, 168)) {
      result.sales = raw.sales;
    } else result.enabled.sales = false;
    result.delivery = raw.delivery || null;
    result.offers = raw.offers || null;
    return result;
  }
  function timestamp(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/.test(value) ||
        dateNumber(value.slice(0, 10)) === null) return NaN;
    return Date.parse(value);
  }
  function salesInfo(settings, snapshot, now) {
    now = now === undefined ? Date.now() : Number(now);
    if (!settings.enabled.sales || !snapshot || snapshot.schema !== 'hah-sales/v1' || snapshot.status !== 'verified' ||
        snapshot.basis !== 'paid_net_units_order_created_last_30_days' || !integer(snapshot.units, 1, Number.MAX_SAFE_INTEGER) ||
        snapshot.units < settings.sales.minimum_units) return null;
    var checked = timestamp(snapshot.checked_at), end = timestamp(snapshot.period_end), start = timestamp(snapshot.period_start);
    // A newly checked snapshot must still represent the current 30-day window.
    // Allow a bounded scan duration, never a fresh timestamp on an old window.
    var expires = Math.min(checked, end) + settings.sales.max_age_hours * 3600000;
    if (![now, checked, start, end].every(Number.isFinite) || start >= end || Math.abs(end - start - 30 * DAY) > 1000 ||
        end > checked || checked - end > 10 * 60000 || checked > now || now >= expires) return null;
    return { units: snapshot.units, expiresAt: expires };
  }
  function savings(price, compare, pending, enabled) {
    if (pending || !enabled || !integer(price, 0, Number.MAX_SAFE_INTEGER) ||
        !integer(compare, 1, Number.MAX_SAFE_INTEGER) || compare <= price) return null;
    var percent = Math.round((compare - price) * 100 / compare);
    return percent > 0 ? { amount: compare - price, percent: percent } : null;
  }
  function offerInfo(settings, snapshot, productId, variantId, currency, now) {
    now = now === undefined ? Date.now() : Number(now);
    var request = settings && settings.offers;
    if (!settings || !settings.enabled.savings || !request || !/^[a-f0-9]{64}$/.test(request.request_hash || '') ||
        !integer(request.max_age_minutes, 5, 60) || !snapshot || snapshot.schema !== 'hah-offers/v1' || snapshot.status !== 'verified' ||
        snapshot.request_hash !== request.request_hash || !/^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(snapshot.product_id || '') ||
        snapshot.product_id.split('/').pop() !== String(productId || '').split('/').pop() || snapshot.currency !== currency ||
        !/^[A-Z]{3}$/.test(currency || '') || !/^[1-9]\d*$/.test(String(variantId || '')) || !Array.isArray(snapshot.items) || snapshot.items.length > 5) return [];
    var checked = timestamp(snapshot.checked_at), expires = timestamp(snapshot.expires_at), ttl = request.max_age_minutes * 60000;
    if (![now, checked, expires].every(Number.isFinite) || checked > now || now >= expires || expires <= checked || expires - checked > ttl) return [];
    function decimal(value, high) { return typeof value === 'string' && /^\d+(?:\.\d+)?$/.test(value) && Number.isFinite(Number(value)) && Number(value) > 0 && Number(value) <= high; }
    var seen = new Set();
    return snapshot.items.filter(function (item) {
      if (!item || typeof item.code !== 'string' || !/^[A-Z0-9_-]{3,64}$/.test(item.code) || seen.has(item.code) ||
          !item.benefit || !item.minimum || !item.scope || !item.combines_with || !/^[a-f0-9]{64}$/.test(item.source_hash || '')) return false;
      var itemChecked = timestamp(item.checked_at), itemExpires = timestamp(item.expires_at), start = timestamp(item.starts_at), updated = timestamp(item.source_updated_at), end = item.ends_at === null ? Infinity : timestamp(item.ends_at);
      if (![itemChecked, itemExpires, start, updated].every(Number.isFinite) || (end !== Infinity && !Number.isFinite(end)) ||
          itemChecked !== checked || itemChecked > now || now >= itemExpires || itemExpires <= itemChecked || itemExpires > expires ||
          itemExpires - itemChecked > ttl || updated > itemChecked || start > now || now >= end || end <= start || itemExpires > end) return false;
      var benefit = item.benefit, minimum = item.minimum, scope = item.scope;
      if (typeof benefit.per_item !== 'boolean' || !decimal(benefit.value, benefit.type === 'percentage' ? 100 : 1000000000) ||
          (benefit.type === 'percentage' ? benefit.currency !== null : benefit.type !== 'amount' || benefit.currency !== currency)) return false;
      if (minimum.type === 'none' ? minimum.value !== null || minimum.currency !== null :
          minimum.type === 'quantity' ? !decimal(minimum.value, 1000000) || !Number.isSafeInteger(Number(minimum.value)) || minimum.currency !== null :
          minimum.type !== 'subtotal' || !decimal(minimum.value, 1000000000) || minimum.currency !== currency) return false;
      if (['all','product','variants'].indexOf(scope.type) < 0 || !Array.isArray(scope.variant_ids) || scope.variant_ids.length > 1000 ||
          new Set(scope.variant_ids).size !== scope.variant_ids.length || scope.variant_ids.some(function (id) { return typeof id !== 'string' || !/^[1-9]\d*$/.test(id); }) ||
          (scope.type === 'variants' ? scope.variant_ids.indexOf(String(variantId)) < 0 : scope.variant_ids.length !== 0) ||
          ['order','product','shipping'].some(function (key) { return typeof item.combines_with[key] !== 'boolean'; })) return false;
      seen.add(item.code); return true;
    });
  }
  function dateNumber(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    var parts = value.split('-').map(Number), time = Date.UTC(parts[0], parts[1] - 1, parts[2]);
    if (parts[0] < 1000 || !Number.isFinite(time) || new Date(time).toISOString().slice(0, 10) !== value) return null;
    return time / DAY;
  }
  function calendar(workdays, holidays) {
    if (!Array.isArray(workdays) || !workdays.length || workdays.length > 7 || new Set(workdays).size !== workdays.length ||
        !workdays.every(function (n) { return integer(n, 1, 7); }) || !Array.isArray(holidays) || holidays.length > 366 ||
        new Set(holidays).size !== holidays.length) return null;
    var dates = holidays.map(dateNumber);
    if (dates.some(function (d) { return d === null; })) return null;
    return { days: new Set(workdays), holidays: new Set(dates) };
  }
  function isWorking(day, cal) { return cal.days.has(new Date(day * DAY).getUTCDay() || 7) && !cal.holidays.has(day); }
  function nextWorking(day, cal) {
    for (var limit = 0; limit < 3000; limit++, day++) if (isWorking(day, cal)) return day;
    throw new Error('No working day in supported range');
  }
  function addWorking(day, count, cal) {
    if (!count) return nextWorking(day, cal);
    for (var limit = 0; count > 0 && limit < 3000; limit++) {
      day++;
      if (isWorking(day, cal)) count--;
    }
    if (count) throw new Error('Working-day range exceeded');
    return day;
  }
  function localClock(now, timezone) {
    var values = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(now)).forEach(function (p) {
      if (p.type !== 'literal') values[p.type] = p.value;
    });
    return { day: dateNumber(values.year + '-' + values.month + '-' + values.day), hour: Number(values.hour) };
  }
  function deliveryProfile(settings) {
    var profile = settings.delivery;
    if (!settings.enabled.delivery || !profile || profile.verified !== true || typeof profile.service !== 'string' || !profile.service.trim() || profile.service.length > 80 ||
        typeof profile.timezone !== 'string' || !integer(profile.cutoff_hour, 0, 23) ||
        !integer(profile.processing_min_days, 0, 90) || !integer(profile.processing_max_days, profile.processing_min_days, 90)) return null;
    try { localClock(Date.now(), profile.timezone); } catch (error) { return null; }
    var production = calendar(profile.workdays, profile.holidays), countries = new Set();
    if (!production || !Array.isArray(profile.transit_by_country) || !profile.transit_by_country.length || profile.transit_by_country.length > 250) return null;
    var routes = [];
    for (var i = 0; i < profile.transit_by_country.length; i++) {
      var route = profile.transit_by_country[i];
      if (!route || typeof route.country !== 'string' || !/^[A-Z]{2}$/.test(route.country) || countries.has(route.country) ||
          !integer(route.min_days, 0, 120) || !integer(route.max_days, route.min_days, 120)) return null;
      var transit = calendar(route.workdays, route.holidays);
      if (!transit) return null;
      countries.add(route.country);
      routes.push({ country: route.country, min: route.min_days, max: route.max_days, calendar: transit });
    }
    return { settings: profile, production: production, routes: routes };
  }
  function dateString(day) { return new Date(day * DAY).toISOString().slice(0, 10); }
  function estimateDelivery(profile, country, now) {
    // A destination must be explicitly selected; browser locale is not a shipping address.
    if (!profile || typeof country !== 'string' || !country) return null;
    var route = profile.routes.find(function (entry) { return entry.country === country; });
    if (!route) return null;
    now = now === undefined ? Date.now() : Number(now);
    if (!Number.isFinite(now)) return null;
    try {
      var settings = profile.settings, clock = localClock(now, settings.timezone);
      if (clock.day === null) return null;
      var accepted = clock.hour < settings.cutoff_hour && isWorking(clock.day, profile.production) ?
        clock.day : nextWorking(clock.day + 1, profile.production);
      var shipMin = addWorking(accepted, settings.processing_min_days, profile.production);
      var shipMax = addWorking(accepted, settings.processing_max_days, profile.production);
      var deliveryMin = addWorking(shipMin, route.min, route.calendar);
      var deliveryMax = addWorking(shipMax, route.max, route.calendar);
      return { country: country, service: settings.service, accepted: dateString(accepted),
        shipMin: dateString(shipMin), shipMax: dateString(shipMax),
        earliest: dateString(deliveryMin), latest: dateString(deliveryMax) };
    } catch (error) { return null; }
  }
  return { config: config, salesInfo: salesInfo, savings: savings, offerInfo: offerInfo, deliveryProfile: deliveryProfile, estimateDelivery: estimateDelivery };
}));
